// 点位测评类型选择项
export const SpotTypeOptions = [
  {
    value: 1,
    label: '街边店'
  },
  {
    value: 2,
    label: '商场店'
  },
];

// 点位测评类型选择项枚举
export const SpotTypeEnum = {
  Street: 1,
  Mall: 2
};

export const filteredCode = 'yht_all_milk_tea_000';

export const radiusOptions = [
  { value: 500, label: '半径：500m' },
  { value: 1000, label: '半径：1km' },
  { value: 1500, label: '半径：1.5km' },
  { value: 2000, label: '半径：2km' },
  { value: 3000, label: '半径：3km' },
];


